import { ROUTES } from '#/config/routes';
import {
  rememberAsyncFilterLabels,
  resolveFromLabelCache,
} from '#/modules/commonComponents/table/asyncFilterLabelCache';
import {
  createAsyncMultiFilterMeta,
  createFixedMultiFilterMeta,
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createEditLinkColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { WAREHOUSE_STATUS_FILTER_OPTIONS } from '#/modules/imsMgmt/settings/storePlace/helper/warehouseFilterOptions';
import { searchWarehouseFilterOptions } from '#/modules/imsMgmt/settings/storePlace/helper/warehouseSelectOptions';

function formatWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '-';
  }

  return warehouse.code ? `${warehouse.code} - ${warehouse.name}` : warehouse.name ?? '-';
}

export function buildWarehouseLocationColumns({
  filters = {},
  onFilterChange,
  warehouseLabelCache,
  canShowEdit = () => true,
}) {
  return [
    createEditLinkColumn({
      getEditPath: (row) => ROUTES.storePlaceLocationEdit(row.id),
      canShowEdit,
    }),
    {
      header: '代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: '代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 200,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
    },
    {
      id: 'warehouse',
      header: '倉別',
      accessorFn: (row) => formatWarehouseLabel(row.warehouse),
      size: 180,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createAsyncMultiFilterMeta({
          key: 'warehouseId',
          label: '倉別',
          searchOptions: searchWarehouseFilterOptions,
          filterValue: filters.warehouseId,
          onChange: (value) => onFilterChange('warehouseId', value),
          resolveFilterDisplay: (values) => resolveFromLabelCache(warehouseLabelCache, values),
          rememberSelectedOptions: (options, values) => {
            rememberAsyncFilterLabels(warehouseLabelCache, options, values);
          },
        }),
      },
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 96,
      enableColumnFilter: true,
      cell: ({ getValue }) => renderEntityStatusBadge(getValue()),
      meta: createFixedMultiFilterMeta({
        key: 'status',
        label: '狀態',
        options: WAREHOUSE_STATUS_FILTER_OPTIONS,
        filterValue: filters.status,
        onChange: (value) => onFilterChange('status', value),
      }),
    },
  ];
}
